define('constants',[
	"localizationService",
	"sessionInfo",
	"moment"
],

function (LocalizationService, SessionInfo, Moment) {
	/**
	 * All numeric and string constants used in OpenAnnotate.
	 */
	var Constants = {
		/**
		 * The numerical key value for Enter/Return key used for events.
		 * @constant
		 */	
		ENTER_KEYCODE: 13,

		/**
		 * The numerical key value for Page Up key used for events
		 * @constant
		 */
		 PAGE_UP_KEYCODE: 33,

		 /**
		 * The numerical key value for Page Up key used for events
		 * @constant
		 */
		 PAGE_DOWN_KEYCODE: 34,

		 /**
		 * The numerical key value for F key used for events
		 * @constant
		 */
		 F_KEY_KEYCODE: 70,

		/**
		 * The numerical key value for C key used for events
		 * @constant
		 */
		C_KEY_KEYCODE: 67,

		/**
		 * The number of characters a person has to type into an auto complete textbox before it populates the dropdown list.
		 * @constant
		 */	
		AUTOCOMPLETE_CHARACTER_COUNT: 3,

		/** 
		 * The window size at which we will increase the size of resizing rectangles for raphael elements.
		 */
		 IPAD_WINDOW_HEIGHT: 1024,

		 /**
		  * The height of the dialog box created for an annotation.
		  */
		DIALOG_HEIGHT: 240,

		/**
		 * An arbitrary amount to put the dialog below the annotation's top
		 */
		LOWERED_DIALOG_DISTANCE: 15,
		
		/**
		 * an arbitrary amount to put the dialog above the annotation's bottom.
		 */
		RAISED_DIALOG_DISTANCE: 35,
		
		/**
		 * A list of statuses that can be used on an annotation. These are the default status types that Adobe uses
		 */
		DEFAULT_STATUSES: [
			LocalizationService.localize('viewer.modal.annotationComment.status.none'), 
			LocalizationService.localize('viewer.toolbar.tools.accepted'), 
			LocalizationService.localize('viewer.modal.annotationComment.status.cancelled'), 
			LocalizationService.localize('viewer.modal.annotationComment.status.completed'), 
			LocalizationService.localize('viewer.toolbar.tools.rejected')
		],

		/**
		 * The constant for the mimetype of PDFs.
		 * @constant
		 */
		MIMETYPE_PDF: "application/pdf",

		/**
		 * The constant for the mimetype of compare PDF.
		 * @constant
		 */
		MIMETYPE_PDF_COMPARE: "application/pdf_compare",

		/**
		 * The constant for the mimetype of tiffs.
		 * @constant
		 */
		MIMETYPE_TIFF: "image/tiff",

		/** 
		 * The constant for the reply annotation type string 
		 */
		ANNOT_TYPE_REPLY : "Reply",

		/** 
		 * The constant for the status annotation type string 
		 */
		ANNOT_TYPE_STATUS: "Status",

		/** 
		 * The constant for the cUSTOM TAG annotation type string 
		 */
		ANNOT_TYPE_TAG1: "Tag1",
		ANNOT_TYPE_TAG2: "Tag2",
		ANNOT_TYPE_TAG3: "Tag3",
		ANNOT_TYPE_TAG4: "Tag4",
		ANNOT_TYPE_TAG5: "Tag5",
		
		/** 
		 * The constant for the file attachment annotation type string 
		 */
		ANNOT_TYPE_FILE_ATTACHMENT : "File Attachment",

		/** 
		 * The constant for the redaction 'annotation' type string 
		 */
		ANNOT_TYPE_ANNOT_REDACTION : "Redaction",

		/** 
		 * The constant for the text redaction 'annotation' type string 
		 */
		ANNOT_TYPE_TEXT_REDACTION: "Text Redaction",

		/** 
		 * The constant for the signature 'annotation' type string 
		 */
		ANNOT_TYPE_ANNOT_SIGNATURE : "Signature",

		/** 
		 * The constant for the checki PDF action string 
		 */
		CHECKIN_PDF : "Checkin PDF",

		/**
		 * The condition evaluator for the latest version
		 */
		CONDITION_EVAL_LATEST_VERSION: "condition-isobjectlatest-conditionevaluator",

		/** 
		 * The constant for the annotation (default) mode parameter.
		 */
		MODE_ANNOTATION: "false",

		/** 
		 * The constant for the signature mode parameter.
		 */
		MODE_SIGNATURE: "signature",

		/** 
		 * The constant for the read only mode parameter.
		 */
		MODE_READ_ONLY: "readOnly",

		/** 
		 * The constant for the redact mode parameter.
		 */
		MODE_REDACT: "redact",

		/** 
		 * The constant for the page select mode parameter.
		 */
		MODE_PAGE_SELECT: "pageSelect",

		/** 
		 * The constant for the presenter mode parameter.
		 */
		MODE_PRESENTER: "preseneter",

		/** 
		 * The constant for the indexer mode parameter.
		 */
		MODE_INDEXER: "indexer",

		/** 
		 * The constant for the viewer with text mode parameter.
		 */
		MODE_VIEWER_WITH_TEXT: "viewerwithtext",

		/**
		 * The constant for document edit mode
		 */
		MODE_EDIT: "edit",

		/**
		 * The constant for openViewer mode
		 */
		MODE_OPEN_VIEWER: "openviewer",

		/** 
		 * The constant for the redact mode parameter.
		 */
		REDACTION_TYPE_AS_COPY: "redactedAsCopy",

		/**
		 * A URL param value that specifies that all pages are to be selected when initializing the view.
		 */
		SELECT_ALL_PAGES: "ALL",

		/**
		 * The status code for password protected documentNavActions
		 */
		FORBIDDEN_STATUS: 403,

		/**
		 * The status code for documents that are renditioning
		 */
		PRECONDITION_FAILED_STATUS: 412,

		/**
		 * The status code for collections that contain both PDFs and images
		 */
		UNPROCESSABLE_ENTITY_STATUS: 422,

		/**
		 * The status code for transformation exceptions. Used for pdfs that contain xfa forms.
		 */
		NOT_IMPLEMENTED_TRANSFORMATION_EXCEPTION_STATUS: 501,

		/**
		 * The config constant for the Scrolling Document View, where pages can be continously scrolled through.
		 * @constant
		 */
		VIEWER_SCROLLING: "ScrollingViewer",


		/**
		 * The config constant for the Slide Document View, where pages can be viewed one at a time, and scrolling zooms in.
		 * @constant
		 */
		VIEWER_SLIDE: "SlideViewer",

		/**
		 * The constant for a map of the target mimetypes for different source mimetypes. Used to bypass OpenSeaDragon 
		 * passing in the source mimetypes which it does not support.
		 * @constant
		 */
		TARGET_MIMETYPE: {
			"application/pdf_compare":"image/png",
			"application/pdf": "image/png",
			"image/tiff": "image/png",
			"image/gif": "image/gif",
			"image/png": "image/png",
			"image/jpeg": "image/jpeg"
		},

		/**
		 * The constant for the transform endpoint used for transforming PDFs and tiffs into pngs
		 * @constant
		 */
		URL_TRANSFORM: "/openannotate/transform",

		/**
		 * The constant for the create teams meeting endpoint used for creating Microsoft Teams meetings
		 * @constant
		 */
		URL_TEAMS_MEETING: "/annotation/teamsAuth",

		/**
		 * The constant for the teams authorize endpoint used for creating Microsoft Teams meetings
		 */
		URL_TEAMS_AUTH_ENDPOINT: "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize",
		
		/**
		 * The constant for the create zoom meeting endpoint used for creating zoom meetings
		 * @constant
		 */
		URL_ZOOM_MEETING: "/annotation/zoomAuth",

		/**
		 * The constant for the zoom authorize endpoint used for creating zoom meetings
		 * @constant
		 */
		URL_ZOOM_AUTH_ENDPOINT: "https://zoom.us/oauth/authorize",

		/**
		 * The constant for the content/content endpoint
		 * @constant
		 */
		URL_CONTENT: "/content/content",

		/**
		 * The constant for determining small screen or large screen css classes
		 * @constant
		 */
		SMALL_SCREEN_SIZE_WIDTH: 1185,

		/**
		 * The constant for zooming the page to fit-to-height
		 * @constant
		 */
		PAGE_ZOOM_FIT_HEIGHT: "fitHeight",

		/**
		 * The constant for zooming the page to fit-to-width
		 * @constant
		 */
		PAGE_ZOOM_FIT_WIDTH: "fitWidth",

		/**
		 * The constant for a map of enabled notifications that can be configured
		 * @constant
		 */
		ENABLED_NOTIFICATIONS: {
			CHAT: "chat",
			REPLY: "reply",
			MENTION: "mention",
			USER_JOINED: "userJoined",
			USER_LEFT: "userLeft",
			PARTICIPANT_FOLLOWING: "participantFollowing",
			PARTICIPANT_BEING_FOLLOWED: "participantBeingFollowed",
			SERVER_CONNECTION: "serverConnection",
			CHECK_IN_ANNOTATIONS: "checkInAnnotations",
			CHECK_IN_ANNOTATIONS_FAILED: "checkInAnnotationsFailed",
			CHECKIN_ANNOTATIONS_FAILED_USERNAMES: "checkInAnnotationsFailedUsernames",
			CHECK_IN_ANNOTATIONS_FINISHED: "checkinAnnotationsFinished",
			REDACTION_FAILED: "burnInRedactionFailed",
			PAGE_SELECT_MODE: "pageSelectMode",
			WELCOME_BACK_PAGE: "welcomeBackPage",
			SAVE: "save",
			LOADED_ANNOTATIONS: "loadedAnnotations",
			SAVE_FINISHED: "saveFinished",
			COPY_PASTE: "copyPaste",
			COPY_PASTE_NOT_READY: "copyPasteNotReady",
			TOO_LARGE_FOR_THUMBNAILS: "tooLargeForThumbnails",
			PAGE_RANGE_INVALID: "pageRangeInvalid",
			LOGSTASH_FAILED: "logstashFailed",
			PORTFOLIO_CONTAINS_NON_PDF: "portfolioContainsNonPdf",
			DOC_HAS_ANNOTATIONS: "docHasAnnotations",
			AFTER_PAGE_LOAD: "afterPageLoad",
			TEXT_LOCATION_DATA_FAILED: "textLocationDataFailed",
			ENTER_SECTIONING_MODE: "enterSectioningMode",
			SECTION_NAME_INVALID: "sectionNameInvalid",
			LIMITED_FUNCTIONAILITY_LARGE_FILE: "limitedFunctionailityLargeFile",
			FOUND_WIDGETS: "foundWidgets",
			FOUND_ERROR: "foundError",
			COLLECTION_OPENED: "collectionOpened",
			FILE_ATTACHMENT_FAILED: "fileAttachmentFailed",
			FILE_ATTACHMENT_PROCESSING: "fileAttachmentProcessing",
			SPLIT_PDF_PAGE_SELECT: "splitPdfSelectPageRange",
			PDF_DOWNLOAD_FAILED: "pdfDownloadFailed",
			PDF_EXTRACT_FAILED: "pdfExtractPagesFailed",
			DOCUMENT_CREATION_FAILED: "documentCreationFailed",
			SWITCH_TO_EDIT_MODE: "switchToEditMode",
			DISPLAY_DOCUMENT_LIST_FAILED: "displayDocumentListFailed",
			ANNOTATION_CONTENT_CONVERTED_TO_PLAINTEXT: "annotationContentConvertedToPlaintext",
			ANNOTATION_CONTENT_FAILED_TO_SAVE: "annotationContentFailedToSave",
			ERROR_DRAWING_TEXT_ANNOTATION: "errorDrawingTextAnnotation",
			ERROR_PARSING_ROWS: "errorParsingRows",
			LICENSE_WARNING: "licenseWarn"
		},

		/**
		 * This is no longer used. BUT: Do not remove (MARC)-(Oh we'll see about that James...) even if you refactor out. This is welburn's legacy.
		 * @global
		 * @deprecated
		 * @default
		 */
		guidPrefix: "welburn-",

		/** 
		 * Used when we are referencing global doc information for the main document.
		 * @global
		 * @constant
		 * @default
		 */
		MAIN_DOCUMENT: 0,

		/** 
		 * Used when we are referencing global doc information for the secondary/side by side document.
		 * @global
		 * @constant
		 * @default
		 */
		SECONDARY_DOCUMENT: 1,

		/**
		 * The options object for button tooltips that use OA's global styling.
		 * @default
		 */
		TOOLTIP_STYLE: {
			delay: {"show": 100, "hide": 250},
			template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow oa-tooltip-arrow"></div><div class="tooltip-inner oa-tooltip"></div></div>'
		},

		/**
		 * A Mapping from mimetype to icon images.
		 * @default
		 */
		MIMETYPE_ICON_MAP: {
			"application/msword"														: "images/icons/msw.gif",
			"application/vnd.ms-word.document.macroEnabled.12" 							: "images/icons/msw.gif",
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document"	: "images/icons/msw.gif",
			"application/vnd.ms-powerpoint.template.macroEnabled.12"					: "images/icons/ppt.gif",
			"application/vnd.openxmlformats-officedocument.presentationml.template"		: "images/icons/ppt.gif",
			"application/vnd.ms-powerpoint.slideshow.macroEnabled.12"					: "images/icons/ppt.gif",
			"application/vnd.openxmlformats-officedocument.presentationml.slideshow"	: "images/icons/ppt.gif",
			"application/vnd.ms-powerpoint"												: "images/icons/ppt.gif",
			"application/vnd.ms-powerpoint.presentation.macroEnabled.12"				: "images/icons/ppt.gif", 
			"application/vnd.openxmlformats-officedocument.presentationml.presentation"	: "images/icons/ppt.gif",
			"application/vnd.visio"														: "images/icons/visio.gif",
			"application/vnd.ms-excel"													: "images/icons/excel.gif",
			"application/vnd.ms-excel.sheet.binary.macroEnabled.12"						: "images/icons/excel.gif",
			"application/vnd.ms-excel.sheet.macroEnabled.12"							: "images/icons/excel.gif",
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"			: "images/icons/excel.gif",
			"application/vnd.ms-excel.template.macroEnabled.12"							: "images/icons/excel.gif",
			"application/vnd.ms-works"													: "images/icons/excel.gif",
			"application/vnd.openxmlformats-officedocument.spreadsheetml.template"		: "images/icons/excel.gif",
			"application/vnd.ms-outlook"												: "images/icons/email.gif",
			"message/rfc822" 															: "images/icons/email.gif",
			"text/html"																	: "images/icons/html.gif",
			"text/jhtml"																: "images/icons/html.gif",
			"text/phtml"																: "images/icons/html.gif",
			"text/shtml"																: "images/icons/html.gif",
			"multipart/related"															: "images/icons/html.gif",
			"text/plain"																: "images/icons/crtext.gif",
			"text/json"																	: "images/icons/crtext.gif",
			"text/xml"																	: "images/icons/xml.gif",
			"text/x-vcard"																: "images/icons/crtext.gif",
			"image/gif"																	: "images/icons/gif.gif",
			"image/jp2"																	: "images/icons/jpeg.gif",
			"image/jpeg"																: "images/icons/jpeg.gif",
			"image/vnd.ms-modi"															: "images/icons/tiff.gif",
			"image/png"																	: "images/icons/gif.gif",
			"image/tiff"																: "images/icons/tiff.gif",
			"application/illustrator"													: "images/icons/illustrator.gif",
			"application/pdf_props"														: "images/icons/pdf.gif",
			"application/pdf_combo"														: "images/icons/pdf.gif",
			"application/pdf"															: "images/icons/pdf.gif",
			"text/pdf"																	: "images/icons/crtext.gif",
			"application/photoshop"														: "images/icons/photoshop.gif",
			"application/x-zip-compressed"												: "images/icons/zip.gif",
			"application/octet-stream"													: "images/icons/unknown.gif",
			"application/x-ms-wmz"														: "images/icons/zip.gif",
			"application/rtf"															: "images/icons/crtext.gif",
			"application/x-url"															: "images/icons/html.gif",
			"image/x-dwg"																: "images/icons/acad.gif"
		},

		/**
		 * The defaults for the xfdf fields of an annotations
		 * @constant
		 */
		GET_XFDF_DEFAULTS: function() {
			return {
				color: "#FF0000",
				content: "",
				creationDate: Moment().valueOf(),
				data: "",
				isEmbedded: false,
				end1: 0,
				end2: 0,
				fileName: "",
				flags: 0,
				generatedName: false,
				gestures: null,
				head: null,
				inReplyTo: "",
				mimetype: "",
				modifyDate: Moment().valueOf(),
				name: "",
				p1: 0,
				p2: 0,
				p3: 0,
				p4: 0,
				page: 0,
				rows: null,
				start1: 0,
				start2: 0,
				state: "",
				subject: null,
				tail: null,
				title: SessionInfo.displayName,
				type: null,
				icon: "",
				appearance: "",
				fontSize: null,
				textAlign: "",
				fillColor: "",
				borderColor: "",
				textColor: "",
				tag: ""
			}
		},
		
		/**
		 * Creates the map between the color and their hex values.
		 */
		COLOR_NAMES_TO_HEX: {
			aliceblue: "#f0f8ff",
			antiquewhite: "#faebd7",
			aqua: "#00ffff",
			aquamarine: "#7fffd4",
			azure: "##f0ffff",
			beige: "#f5f5dc",
			bisque: "#ffe4c4",
			black: "#000000",
			blanchedalmond: "#ffebcd",
			blue: "#0000ff",
			blueviolet: "#8a2be2",
			brown: "#a52a2a",
			burlywood: "#deb887",
			burntsienna: "#ea7e5d",
			cadetblue: "#5f9ea0",
			chartreuse: "#7fff00",
			chocolate: "#d2691e",
			coral: "#ff7f50",
			cornflowerblue: "#6495ed",
			cornsilk: "#fff8dc",
			crimson: "#dc143c",
			cyan: "#00ffff",
			darkblue: "#00008b",
			darkcyan: "#008b8b",
			darkgoldenrod: "#b8860b",
			darkgray: "#a9a9a9",
			darkgreen: "#006400",
			darkgrey: "#a9a9a9",
			darkkhaki: "#bdb76b",
			darkmagenta: "#8b008b",
			darkolivegreen: "#556b2f",
			darkorange: "#ff8c00",
			darkorchid: "#9932cc",
			darkred: "#8b0000",
			darksalmon: "#e9967a",
			darkseagreen: "#8fbc8f",
			darkslateblue: "#483d8b",
			darkslategray: "#2f4f4f",
			darkslategrey: "#2f4f4f",
			darkturquoise: "#00ced1",
			darkviolet: "#9400d3",
			deeppink: "#ff1493",
			deepskyblue: "#00bfff",
			dimgray: "#696969",
			dimgrey: "#696969",
			dodgerblue:"#1e90ff",
			firebrick: "#b22222",
			floralwhite: "#fffaf0",
			forestgreen: "#228b22",
			fuchsia: "#ff00ff",
			gainsboro: "#dcdcdc",
			ghostwhite: "#f8f8ff",
			gold: "#ffd700",
			goldenrod: "#daa520",
			gray: "#808080",
			green: "#008000",
			greenyellow: "#adff2f",
			grey: "#808080",
			honeydew: "#f0fff0",
			hotpink: "#ff69b4",
			indianred: "#cd5c5c",
			indigo: "#4b0082",
			ivory: "#fffff0",
			khaki: "#f0e68c",
			lavender: "#e6e6fa",
			lavenderblush: "#fff0f5",
			lawngreen: "#7cfc00",
			lemonchiffon: "#fffacd",
			lightblue: "#add8e6",
			lightcoral: "#f08080",
			lightcyan: "#e0ffff",
			lightgoldenrodyellow: "##fafad2",
			lightgray: "#d3d3d3",
			lightgreen:"#90ee90",
			lightgrey: "#d3d3d3",
			lightpink: "#ffb6c1",
			lightsalmon: "#ffa07a",
			lightseagreen: "#20b2aa",
			lightskyblue: "#87cefa",
			lightslategray: "#778899",
			lightslategrey: "#778899",
			lightsteelblue: "#b0c4de",
			lightyellow: "#ffffe0",
			lime: "#00ff00",
			limegreen: "#32cd32",
			linen: "#faf0e6",
			magenta: "#ff00ff",
			maroon: "#800000",
			mediumaquamarine: "#66cdaa",
			mediumblue: "#0000cd",
			mediumorchid: "#ba55d3",
			mediumpurple: "#9370db",
			mediumseagreen: "#3cb371",
			mediumslateblue: "#7b68ee",
			mediumspringgreen: "#00fa9a",
			mediumturquoise: "#48d1cc",
			mediumvioletred: "#c71585",
			midnightblue: "#191970",
			mintcream: "#f5fffa",
			mistyrose: "#ffe4e1",
			moccasin: "#ffe4b5",
			navajowhite: "#ffdead",
			navy: "#000080",
			oldlace: "#fdf5e6",
			olive: "#808000",
			olivedrab: "#6b8e23",
			orange: "#ffa500",
			orangered: "#ff4500",
			orchid: "#da70d6",
			palegoldenrod: "#eee8aa",
			palegreen: "#98fb98",
			paleturquoise: "#afeeee",
			palevioletred: "#db7093",
			papayawhip: "#ffefd5",
			peachpuff: "#ffdab9",
			peru: "#cd853f",
			pink: "#ffc0cb",
			plum: "#dda0dd",
			powderblue: "#b0e0e6",
			purple: "#800080",
			red: "#ff0000",
			rosybrown: "#bc8f8f",
			royalblue: "#4169e1",
			saddlebrown: "#8b4513",
			salmon: "#fa8072",
			sandybrown:"#f4a460",
			seagreen: "#2e8b57",
			seashell: "#fff5ee",
			sienna: "#a0522d",
			silver: "#c0c0c0",
			skyblue:"#87ceeb",
			slateblue: "#6a5acd",
			slategray: "#708090",
			slategrey: "#708090",
			snow: "#fffafa",
			springgreen: "#00ff7f",
			steelblue: "#4682b4",
			tan: "#d2b48c",
			teal: "#008080",
			thistle: "#d8bfd8",
			tomato: "#ff6347",
			turquoise: "#40e0d0",
			violet: "#ee82ee",
			wheat: "#f5deb3",
			white: "#ffffff",
			whitesmoke: "#f5f5f5",
			yellow: "#ffff00",
			darkyellow: "#e5e500", // custom color: reduced from ootb yellow for better contrast on white for accesibility
			yellowgreen: "#9acd32"
		},

		ANNOTATION_XFDFTYPE_TO_DISPLAYNAME: {
			"Cross-Out": LocalizationService.localize("viewer.toolbar.tools.strikeout"),
			"Highlight": LocalizationService.localize("viewer.toolbar.tools.highlight"),
			"Text Redaction": LocalizationService.localize("viewer.toolbar.tools.textRedaction"),
			"Underline": LocalizationService.localize("viewer.toolbar.tools.underline"),
			"Replacement Text": LocalizationService.localize("viewer.toolbar.tools.replacementText"),
			"Inserted Text": LocalizationService.localize("viewer.toolbar.tools.insertedText")
		},

		PAGE_SELECTION_ACTIONS: {
			EXTRACT_PAGES: "extractPages",
			SPLIT_PDF: "splitPdf",
			PRUNE_PDF: "prunePdf",
			DELETE_PAGES: "deletePages"
		}
	};

	// Any constant properties that depend on other constant properties must be initialized
	// after the overall constants object is initialized
	Constants.DEFERRED_ANNOT_TYPES = [Constants.ANNOT_TYPE_STATUS, Constants.ANNOT_TYPE_REPLY
		, Constants.ANNOT_TYPE_TAG1, Constants.ANNOT_TYPE_TAG2, Constants.ANNOT_TYPE_TAG3
		, Constants.ANNOT_TYPE_TAG4, Constants.ANNOT_TYPE_TAG5
	];

	// Reverse the key value pairs of COLOR_NAMES_TO_HEX in order to get 
	// the actual color instead of its hex value while setting the default color
	Constants.HEX_TO_COLOR_NAMES = _.invert(Constants.COLOR_NAMES_TO_HEX)

	Constants.customTagTypes = {
		"Tag1": "", "Tag2": "", "Tag3": "", "Tag4": "", "Tag5": "",
		"Tag1Value": "", "Tag2Value": "", "Tag3Value": "", "Tag4Value": "", "Tag5Value": ""
	};

	return Constants;
});
